import { Checkbox } from '@thoughtspot/radiant-react/widgets/checkbox';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useCallback } from 'react';
import styles from './checkbox-input.module.scss';
export const CheckboxInput = ({ title, description, checked, onChange, name, disabled, }) => {
    const handleChange = useCallback((e) => {
        if (!disabled) {
            onChange(e);
        }
    }, [onChange, disabled]);
    const label = (React.createElement("div", { className: styles.label },
        React.createElement(Typography, { variant: "content-label" }, title),
        description && (React.createElement(Typography, { variant: "body-normal", color: Colors.info, ellipsis: { rows: 2 } }, description))));
    return (React.createElement(Checkbox, { id: name, label: label, checked: checked, onChange: handleChange, disabled: disabled, ariaLabel: title, isList: true, wrapLabel: true, className: styles.checkbox, customLabelClassName: styles.labelWrapper, "data-testid": `feature-checkbox-${name}` }));
};
//# sourceMappingURL=checkbox-input.js.map